const Location = {

    // FIELDS
    "name": "Name",
    "department": "Department",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "location": "Location",

    // ERROR
    "error_name": "Enter Name",
    "error_department": "Select Department",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_department": "DEPARTMENT",
    "table_status": "STATUS",

}

export default Location;